import { api } from '@/api';

const getInvestors = (params) => {
  return api.get('/api/v1/admin/investors', { params: params });
};

const getInvestor = (id) => {
  return api.get('/api/v1/admin/investor', { params: { investorId: id } });
};
const getInvestorCitizenship = (id) => {
  return api.get('/api/kyc/v1/admin/investor/citizenship', {
    params: { investorId: id }
  });
};
const getInvestorAddInfoQuestId = (id) => {
  return api.get('/api/kyc/v1/admin/questionnaires/PersonalData', {
    params: { investorId: id }
  });
};

const getAvatar = (url) => {
  return api.get(`/${url}`, {
    responseType: 'blob'
  });
};

const updateInvestor = (data) => {
  return api.put('/api/v1/admin/investor', data);
};

const updateInvestorAvatar = (investorId, file) => {
  const formData = new FormData();
  formData.append('investorId', investorId);
  formData.append('file', file);

  return api.post('/api/kyc/v1/admin/investor/avatar', formData);
};

const updateUserRole = ({ investorId, role }) => {
  return api.put('/api/kyc/v1/admin/investor/role', { investorId, role });
};
const updateQuestionnaireAccess = ({ investorId, isAccessibleWithoutVerification }) => {
  return api.put('/api/v1/admin/investor', { investorId, isAccessibleWithoutVerification });
};

const getAdminNotifications = (params) => {
  return api.get('/api/kyc/v1/admin/notifications', {
    params: { ...params }
  });
};

const readAdminNotifications = (notificationIds) => {
  return api.put('/api/kyc/v1/admin/notifications/read', {
    notificationIds: notificationIds
  });
};

const getAdminInvestorScoring = ({ investorId, questionSectionTypeId }) => {
  return api.get('/api/kyc/v1/admin/investor/scoring/questionSectionType', {
    params: {
      investorId: investorId,
      questionSectionTypeId: questionSectionTypeId
    }
  });
};

export const downloadPdf = (url) => {
  return api.get(`/${url}`, {
    responseType: 'blob'
  });
};

export * from './kyc';
export * from './localization';
export * from './referrals';

export const adminApi = {
  getInvestors,
  getInvestor,
  getInvestorCitizenship,
  getInvestorAddInfoQuestId,
  getAvatar,
  updateInvestor,
  updateUserRole,
  updateInvestorAvatar,
  updateQuestionnaireAccess,
  getAdminNotifications,
  readAdminNotifications,
  getAdminInvestorScoring,
  downloadPdf
};
